<div class="row">
    <div class="head-component m-b-25">
        <div class="col-10 br-0 m-0 head-component for-fixed-component card border-0">
            <div class="col-9 p-l-5 p-r-45 card-body d-flex align-items-center">
                <div>
                    <h5 class="m-0 head-main-component">
                        Surveys
                    </h5>
                </div>
                <div class="create-process" id="btn_new_survey">
                    <span class="lh-1-1 pl-1 pr-1">
                        Create<br /> new<br /> survey
                    </span>
                    <span class="btn-circle" [routerLink]="['/admin/survey-editor']">
                        <i class="ti-plus text-info"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-9 p-l-25">
        <div *ngFor="let survey of surveys | filter : ['name'] : searchInput.value" class="m-b-15 card cursor-pointer base-shadow-list b-0" (click)="onSurveyClicked(survey)">
            <div class="row card-body p-l-15 pr-0">
                <div class="survey-head col-12 p-l-20" id="survey_name_inlist">{{ survey.name }}</div>
                <div class="col-12 p-l-20" id="survey_description_inlist">{{ survey.description }}</div>
            </div>
            <div class="process-state" [ngClass]="{'state-completed' : survey.isAssignedToProcess, 'state-active' : !survey.isAssignedToProcess}">
            </div>
        </div>
    </div>
    <div class="col-3 pl-0">
        <div class="card border-none bg-none pl-0 position-relative fixed-search-block">
            <div class="bg-none p-l-10 pt-0 pr-0 fixed-right">
                <div class="col-12 mt-2 p-0">
                    <div class="mb-1" id="survey_block_name">
                        Survey name
                    </div>
                    <div>
                        <input class="w-100 search-filter" id="surveys_search" type="text" #searchInput (keyup)="searchInput.value" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>